import * as React from 'react';
import { ArticleHeading1, Responsive } from '@cian/ui-kit';
import { ErrorLogComponent } from '@cian/error-log-component';
import { ProjectsOnMapRedesigned as ProjectsOnMapComponent } from '../../components/ProjectsOnMap';
import { Map } from '../Map/MapRedesigned';
import { trackShowProjectsMap } from './tracking';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { useApplicationContext } from '../../utils';

/**
 * Карта инициализируется в componentDidMount стороннего компонента и зависит от matchMedia и api-maps.
 * Локальный boundary: при ошибке исчезает только блок карты, а не вся карточка застройщика.
 */
export function ProjectsOnMap() {
  const { logger } = useApplicationContext();

  return (
    <Responsive desktop>
      <ErrorLogComponent logger={logger}>
        <ActionAfterViewed callback={trackShowProjectsMap}>
          <ProjectsOnMapComponent title={<ArticleHeading1 as="h2">Объекты на карте</ArticleHeading1>} map={<Map />} />
        </ActionAfterViewed>
      </ErrorLogComponent>
    </Responsive>
  );
}
